import { Component } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import { Pagination } from 'antd'
import { DEFAULT_NO_FOUND_DESCRIPTION } from '../../../../constants/globalTypes'
import YTable from '../../YTable'
import styles from './Table.css'
import NoData from '../../NoData/NoData'
import Readmore from './Readmore/Readmore'

class Table extends Component {
  handlePaginationClick = e => {
    const { paginationProps: { onClick } } = this.props
    const currentEle = _.get(e, 'target.nodeName')
    if (currentEle === 'A') {
      onClick && onClick(e)
    }
  }

  render () {
    const {
      sectionClassName,
      className,
      data,
      noBorder,
      noStripe,
      noDataText = DEFAULT_NO_FOUND_DESCRIPTION,
      readmoreProps,
      showPagination = false,
      paginationProps: {
        onPaginationClick,
        ...restPaginationProps
      } = {},
      ...restProps
    } = this.props
    const isNoData = _.size(data) === 0
    const hasReadmore = !isNoData && !_.isEmpty(readmoreProps)
    const resultTotal = _.get(restPaginationProps, 'total')
    const isPaginationVisible = (
      showPagination &&
      // antd 預設 currentPage 需要有 total 才會正確綁定，
      // 通常拿到 total 都是打 api 才會拿到 totalResult，
      // 所以需要等到有 total 才顯示分頁
      (
        !_.isUndefined(resultTotal) &&
        resultTotal > 0
      )
    )

    return (
      <>
        <section
          className={clx(
            styles.tableSection,
            { [styles.noBorder]: noBorder },
            sectionClassName
          )}
        >
          <YTable
            key='table'
            className={clx(
              styles.table,
              className,
              { [styles.noDataRow]: isNoData },
              { [styles.noStripe]: noStripe },
              { [styles.hasReadmore]: hasReadmore }
            )}
            data={data}
            // 分頁用 antd 的
            showPagination={false}
            noDataText={(
              <NoData
                className={styles.NoData}
                description={noDataText}
              />
            )}
            {...restProps}
          />
          {
            hasReadmore && (
              <Readmore
                key='readmore'
                {...readmoreProps}
              />
            )}
        </section>
        {
          isPaginationVisible && (
            <div onClick={this.handlePaginationClick}>
              <Pagination
                key='pagination'
                defaultCurrent={1}
                pageSize={20}
                showSizeChanger={false}
                {...restPaginationProps}
              />
            </div>
          )}
      </>
    )
  }
}

export default Table
